import Entity from "./entity";
import GameMap from "./map";

export default class Campaign {
    id!: string;
    universeId!: string
    name = '';
    description = '';
    entities: Entity[] = [];
    maps: GameMap[] = [];

    constructor(data?: any) {
        if (data) {
            if (typeof data !== "object") data = JSON.parse(data);
            Object.assign(this, data);
        }

        this.entities = (this.entities ?? []).map((entity) => new Entity(entity));
        this.maps = (this.maps ?? []).map((map) => new GameMap(map));
    }
}
